
import React from 'react'

import Footer from '../../../general/footer/Footer';

import client2 from '../../../assets/client2.jpg'
import img2 from "../../../assets/img2.jpg";
import stockbrokingimg1 from "../../../assets/stockbrokingimg1.jpg";
import { Link } from 'react-router-dom';

const NRI = () => {
    return (
        <div>
            <div className="insurance-section">
                <div className="insurance-content">
                    <div className="breadcrumb">
                        <span>Home</span> &nbsp;•&nbsp;
                        <span>Our Services</span> &nbsp;•&nbsp;
                        <span className="active">Stock Broking </span>
                    </div>
                    <h1>Stock Broking Services</h1>
                    <p>
                        At PSJ Capital Ventures, we offer comprehensive stock broking services as an Authorized Partner with IIFL Capital, one of India’s most respected and technology-forward financial institutions. This strategic collaboration allows us to bring the best of both worlds to our clients — a robust trading platform backed by IIFL’s infrastructure, and personalized advisory and hand-holding from our in-house experts at PSJ.
                    </p>
                </div>
                <div className="insurance-image">
                    <img src={stockbrokingimg1} alt="Insurance Family" />
                </div>
            </div>

            <div className="travel-details-container">
                {/* LEFT SECTION */}
                <div className="travel-details-left">
                    {/* <h2>Navigating Markets with a Macro Lens.</h2>
                    <p>
                       Whether you're a family office, corporate treasury, HNI investor, or portfolio manager, our macro research serves as the backbone for informed decision-making across asset classes - equities, debt, currency, commodities, and alternatives.
                    </p> */}


                    <h3 style={{ color: 'black' }}>Services Under Our Stock Broking Offering</h3>

                    <h5>1. Equity Trading</h5>
                    <ul>
                        <li>Invest in large-cap, mid-cap, small-cap, and micro-cap stocks across sectors</li>
                        <li>Both delivery-based investing and intraday trading options</li>
                        <li>Live market tracking with actionable alerts</li>
                    </ul>

                    <h5>2.Derivatives Trading (Futures & Options)</h5>
                    <ul>
                        <li>	For clients looking to hedge or speculate using leverage</li>
                        <li>	Strategy-building assistance for options spreads, covered calls, protective puts, etc.</li>
                        <li>	Weekly training and market outlooks</li>
                    </ul>
                    <h5>3. IPO & Pre-IPO Access</h5>
                    <ul>
                        <li>	Apply for upcoming IPOs directly through your IIFL trading account</li>
                        <li>	Pre-IPO research briefs and anchor allocation insights via our team</li>
                    </ul>
                    <h5>4. Mutual Fund, Bonds, and ETF Integration</h5>
                    <ul>
                        <li>	Invest across asset classes directly via the same IIFL dashboard</li>
                        <li>	Combine equity trading with long-term SIPs, tax-saving bonds, or sector ETFs</li>
                    </ul>
                    <h5>5. HNI & Business Family Desk</h5>
                    <ul>
                        <li>	Treasury investment management using listed equities</li>
                        <li>	Tax harvesting strategies</li>
                        <li>	Corporate accounts & demat setups for family trusts</li>
                    </ul>


                    <h3 style={{ color: 'black' }}>Who Is It For?</h3>
                    <div className="plan-columns">

                        <div>
                            <h5>1.	Retail Investors </h5>
                            <p>Looking for both guidance and DIY flexibility
                            </p>
                            <h5>2.	First-Time Traders: </h5>
                            <p>Needing education, hand-holding, and platform support</p>
                        </div>
                        <div>
                            <h5>3. 	Business Families </h5>
                            <p>Managing corporate reserves or family office funds</p>
                            <h5>4. HNIs & NRIs </h5>
                            <p>Seeking India-focused equity exposure</p>
                        </div>
                    </div>

                    {/* Service Benefits */}
                    <div className="benefits-section">
                        <div className="benefits-image">
                            <img src={img2} alt="Service Benefits" />
                        </div>
                        <div className="benefits-list">
                            <h4>Why Choose PSJ Capital for Stock Broking?</h4>
                            {/* <p>
                                We help you invest across a wide spectrum of mutual fund categories:
                            </p> */}
                            <ul>
                                <li>✓ 	•	Access to IIFL’s Award-Winning Trading Platform</li>
                                <li>✓ 	•	Research-Backed Handholding </li>
                                <li>✓ 	•	Dedicated Relationship Management </li>
                            </ul>
                        </div>
                    </div>






                    {/* More Benefits */}
                    <div className="service-benefits">
                        <h3>How to Get Started</h3>

                        <ul>
                            <li>1.	Contact us or schedule a free consultation call</li>
                            <li>2.	Complete eKYC and onboarding via IIFL Capital</li>
                            <li>3.	Begin investing/trading with real-time support from our team
                                We’ll walk you through the platform, set up your account, and help you build your first portfolio or trading strategy.
                            </li>
                        </ul>
                        <p>
                            With IIFL Capital’s 25+ years of capital market experience and PSJ Capital Ventures’ boutique wealth advisory edge, we offer a powerful, modern stock broking solution that goes far beyond just placing trades.


                        </p>
                    </div>
                    <Link to='/contact'><button className="get-touch-btn">Get in Touch →</button></Link>
                </div>

                {/* RIGHT SECTION */}
                <div className="travel-details-right">
                    <div className="services-box">
                        <h4>Our Services</h4>
                        <ul>
                            <Link to='/mutual-funds'><li>mutual-funds →</li></Link>
                            <Link to='/portfolio-management-services'><li>Portfolio Management Services →</li></Link>
                            <Link to='/alternative-investment-funds'><li>Alternative Investment Funds →</li></Link>
                            <Link to='/macro-treasury-research'><li>Macro/Treasury Research →</li></Link>
                            <Link to='/family-offices'><li>Family Offices →</li></Link>
                            <Link to='/nri-corner'><li>NRI Corner →</li></Link>
                            <Link to='/insurance'><li>Insurance →</li></Link>
                            <Link to='/loan-syndication'><li>Loan Syndication→</li></Link>
                            <Link to='/sme-ipo-advisory'><li>SME IPO Advisory →</li></Link>
                            <Link to='/fundraising-assistance'><li>Fundraising Assistance →</li></Link>
                            
                        </ul>
                    </div>

                    <div className="advisor-box">
                        <img src={client2} alt="Advisor" />
                        <p>Make your dream life get professional help</p>
                        <div className="contact-info">
                            <span>📞 CONTACT US</span>
                            <p>+91 8108 430 942</p>
                        </div>
                    </div>
                </div>
            </div>
            <br></br><br></br><br></br>
            <Footer />
        </div>
    )
}

export default NRI